export default "__VITE_ASSET__BJ4zriD3__"